<template>
  <div class="">
    <div class="measure-result" v-if="assessType === 'cropSprouting'">
      <div class="crop-buttons">
        <v-btn height="32" class="crop-btn" :class="{ active: selectedCrop === 'corn' }" @click="selectCrop('corn')">
          <v-icon>mdi-corn</v-icon>
          <span v-if="!iconsOnly" class="crop-name">玉米</span>
        </v-btn>
        <v-btn height="32" class="crop-btn" :class="{ active: selectedCrop === 'peanut' }" @click="selectCrop('peanut')">
          <v-icon>mdi-peanut</v-icon>
          <span v-if="!iconsOnly" class="crop-name">花生</span>
        </v-btn>
        <v-btn height="32" class="crop-btn" :class="{ active: selectedCrop === 'rice' }" @click="selectCrop('rice')">
          <v-icon>mdi-barley</v-icon>
          <span v-if="!iconsOnly" class="crop-name">水稻</span>
        </v-btn>
        <v-btn height="32" class="crop-btn" :class="{ active: selectedCrop === 'soybean' }" @click="selectCrop('soybean')">
          <v-icon>mdi-sprout</v-icon>
          <span v-if="!iconsOnly" class="crop-name">大豆</span>
        </v-btn>
      </div>
    </div>
    <div class="measure-result" v-if="assessType === 'cropGrowth'">
      <div class="crop-buttons">
        <v-btn height="32" class="crop-btn" :class="{ active: selectedCrop === 'corn' }" @click="selectCrop('corn')">
          <v-icon>mdi-corn</v-icon>
          <span v-if="!iconsOnly" class="crop-name">玉米</span>
        </v-btn>
        <v-btn height="32" class="crop-btn" :class="{ active: selectedCrop === 'peanut' }" @click="selectCrop('peanut')">
          <v-icon>mdi-peanut</v-icon>
          <span v-if="!iconsOnly" class="crop-name">花生</span>
        </v-btn>
        <v-btn height="32" class="crop-btn" :class="{ active: selectedCrop === 'rice' }" @click="selectCrop('rice')">
          <v-icon>mdi-barley</v-icon>
          <span v-if="!iconsOnly" class="crop-name">水稻</span>
        </v-btn>
        <v-btn height="32" class="crop-btn" :class="{ active: selectedCrop === 'soybean' }" @click="selectCrop('soybean')">
          <v-icon>mdi-sprout</v-icon>
          <span v-if="!iconsOnly" class="crop-name">大豆</span>
        </v-btn>
      </div>
    </div>
    <div class="measure-result" v-if="assessType === 'cropYield'">
      <div class="crop-buttons">
        <v-btn height="32" class="crop-btn" :class="{ active: selectedCrop === 'corn' }" @click="selectCrop('corn')">
          <v-icon>mdi-corn</v-icon>
          <span v-if="!iconsOnly" class="crop-name">玉米</span>
        </v-btn>
        <v-btn height="32" class="crop-btn" :class="{ active: selectedCrop === 'peanut' }" @click="selectCrop('peanut')">
          <v-icon>mdi-peanut</v-icon>
          <span v-if="!iconsOnly" class="crop-name">花生</span>
        </v-btn>
        <v-btn height="32" class="crop-btn" :class="{ active: selectedCrop === 'rice' }" @click="selectCrop('rice')">
          <v-icon>mdi-barley</v-icon>
          <span v-if="!iconsOnly" class="crop-name">水稻</span>
        </v-btn>
        <v-btn height="32" class="crop-btn" :class="{ active: selectedCrop === 'soybean' }" @click="selectCrop('soybean')">
          <v-icon>mdi-sprout</v-icon>
          <span v-if="!iconsOnly" class="crop-name">大豆</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ks-assess-result',
  props: {
    measureGeom: { type: Object },
    assessType: { type: String },
    trusteeLands: { type: Array }
  },
  data () {
    return {
      snackbar: false,
      noitfyText: '',
      selectedCrop: 'corn',
      iconsOnly: false
    }
  },
  created () {
    // Set initial crop in store
    this.$store.commit('setSelectedCrop', { value: 'corn', name: '玉米' });
  },
  methods: {
    selectCrop (crop) {
      this.selectedCrop = crop;
      this.$store.commit('setSelectedCrop', { value: crop, name: crop });
      // You can add additional logic here for crop selection
    }
  }
}
</script>

<style scoped>
.measure-result {
  font-size: 14px;
  padding-left: 8px;
  padding-bottom: 8px;
}

.centered-snackbar {
  left: 50%;
  top: 4em;
  transform: translate(-50%, -50%);
  /* z-index: 2000; */
}

.crop-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.crop-btn {
  text-transform: none !important;
}

.crop-name {
  margin-left: 8px;
}

.v-btn.active {
  background-color: #4CAF50 !important;
  color: white !important;
}
</style>
